import { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { AssetIcon } from 'src/assets/icons/AssetIcon';
import { CollapsingTooltip } from 'src/components/CollapsingTooltip';
import { TruncatedTypography, TYPOGRAPHY_VARIANT } from 'src/components/TruncatedTypography';
import { PROMPT_ACTION } from 'src/data/prompt';

import { BaseMenuItem } from '../BaseMenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    subtitle: PropTypes.string,
    body: PropTypes.string,
    title: PropTypes.string,
    emptyState: PropTypes.bool,
    brandVoiceName: PropTypes.string,
  }).isRequired,
  onAction: PropTypes.func.isRequired,
  isApplicationModeInfinity: PropTypes.bool,
};

const defaultProps = {
  className: '',
  isApplicationModeInfinity: false,
};

export const MenuItemBank = ({ className, item, onAction, isApplicationModeInfinity }) => {
  const styles = useStyles();

  const handleClick = useCallback(() => {
    onAction(PROMPT_ACTION.insertBrandBrief, {
      item,
    });
  }, [item, onAction]);

  return (
    <CollapsingTooltip
      title={item.body ? item.label + ' • ' + item.subtitle + ':\n\n' + item.body : ''}
      placement={isApplicationModeInfinity ? 'bottom' : 'right'}
      cutoffLength={isApplicationModeInfinity ? 160 : 300}
      enterDelay={500}
      arrow
    >
      <BaseMenuItem
        className={cx(styles.root, className)}
        item={item}
        onClick={handleClick}
        data-testid="messagingBankMenuItem"
      >
        {!item.title && !item.emptyState && <AssetIcon className={styles.assetIcon} />}

        <div className={styles.content}>
          {item.label && (
            <TruncatedTypography
              className={styles.label}
              variant={TYPOGRAPHY_VARIANT.medium14}
              hideTooltip
            >
              {item.label}
            </TruncatedTypography>
          )}

          <TruncatedTypography
            className={styles.body}
            variant={TYPOGRAPHY_VARIANT.regular12}
            hideTooltip
          >
            {item.subtitle} {item.brandVoiceName && ' • ' + item.brandVoiceName}
          </TruncatedTypography>

          {item.body && (
            <TruncatedTypography
              className={styles.body}
              variant={TYPOGRAPHY_VARIANT.regular12}
              hideTooltip
            >
              {item.body}
            </TruncatedTypography>
          )}
        </div>
      </BaseMenuItem>
    </CollapsingTooltip>
  );
};

MenuItemBank.propTypes = propTypes;
MenuItemBank.defaultProps = defaultProps;
